/**
 * Плагин обратного отсчёта до начала матча
 *
 * @param {number} timestamp TimeStamp даты начала матча
 * @param {number} serverTime TimeStamp времени на сервере
 * @param {string} lang Локализация сайта
 */
$.fn.gameStartCountdown = function (timestamp, serverTime, lang = 'ru') {
    timestamp = (typeof timestamp !== 'undefined') ? timestamp : 0;

    var $wrapper = $(this);

    var placeholder = '--';

    var $days = $wrapper.find('.js-days');
    var $daysText = $days.closest('.js-timer-item').find('.js-text-timer');

    var $hours = $wrapper.find('.js-hours');
    var $hoursText = $hours.closest('.js-timer-item').find('.js-text-timer');

    var $minutes = $wrapper.find('.js-minutes');
    var $minutesText = $minutes.closest('.js-timer-item').find('.js-text-timer');

    var $seconds = $wrapper.find('.js-seconds');
    var $secondsText = $seconds.closest('.js-timer-item').find('.js-text-timer');

    var currentDate = undefined;
    var gameDate = undefined;
    var interval = undefined;
    var serveTimeDiff = (new Date().getTime()) - (serverTime * 1000);

    var daysText = (lang === 'ru') ? ['день', 'дня', 'дней'] : ['day', 'days', 'days'];
    var hourText = (lang === 'ru') ? ['час', 'часа', 'часов'] : ['hour', 'hours', 'hours'];
    var minuteText = (lang === 'ru') ? ['минута', 'минуты', 'минут'] : ['minute', 'minutes', 'minutes'];
    var secondsText = (lang === 'ru') ? ['секунда', 'секунды', 'секунд'] : ['second', 'seconds', 'seconds'];

    var dateDiffMs = 0;
    var secondsLeft = 0;
    var minutesLeft = 0;
    var hoursLeft = 0;
    var daysLeft = 0;


    /**
     * Склонения слов
     * @param {number} number
     * @param {array} words
     *
     * @returns {string}
     */

    var getDeclOfNum = function (number, words) {
        var numberSecond;

        number = Math.abs(number) % 100;
        numberSecond = number % 10;

        if (number > 10 && number < 20) {
            return words[2];
        }

        if (numberSecond > 1 && numberSecond < 5) {
            return words[1];
        }

        if (numberSecond === 1) {
            return words[0];
        }

        return words[2];
    };

    /**
     * Запускает обратный отсчёт
     */
    var startCountdown = function () {
        interval = setInterval(function () {
            var currentTimeMs = (new Date().getTime()) - serveTimeDiff;
            currentDate = new Date(currentTimeMs);
            dateDiffMs = gameDate - currentDate;

            if (dateDiffMs < 1 && typeof interval !== 'undefined') {
                stopCountdown();
            }

            secondsLeft = Math.floor(dateDiffMs / 1000);
            minutesLeft = Math.floor(secondsLeft / 60);
            secondsLeft = secondsLeft % 60;
            hoursLeft = Math.floor(minutesLeft / 60);
            minutesLeft = minutesLeft % 60;
            daysLeft = Math.floor(hoursLeft / 24);
            hoursLeft = hoursLeft % 24;

            updateHtml();
        }, 1000);
    };

    /**
     * Останавливает обратный отсчёт
     */
    var stopCountdown = function () {
        clearInterval(interval);
        resetHtml();
    };

    /**
     * Возвращает число в ведущим нулём
     *
     * @param {number} number
     *
     * @returns {string}
     */
    var getNumberWithLeadingZero = function (number) {
        return (number < 10) ? '0' + number : number.toString()
    };

    /**
     * Обновляет HTML
     */
    var updateHtml = function () {
        $days.html(getNumberWithLeadingZero(daysLeft));
        $hours.html(getNumberWithLeadingZero(hoursLeft));
        $minutes.html(getNumberWithLeadingZero(minutesLeft));
        $seconds.html(getNumberWithLeadingZero(secondsLeft));

        $daysText.html(getDeclOfNum(daysLeft, daysText));
        $hoursText.html(getDeclOfNum(hoursLeft, hourText));
        $minutesText.html(getDeclOfNum(minutesLeft, minuteText));
        $secondsText.html(getDeclOfNum(secondsLeft, secondsText));
    };

    /**
     * Сбрасываем HTML
     */
    var resetHtml = function () {
        $days.html(placeholder);
        $hours.html(placeholder);
        $minutes.html(placeholder);
        $seconds.html(placeholder);
    };

    /**
     * Инициализация плагина
     */
    var init = function () {
        if (typeof timestamp !== 'number') {
            console.warn('matchCountdown: incorrect game start timestamp!');
            return;
        }

        if (timestamp === 0) {
            return;
        }

        gameDate = new Date(timestamp * 1000);

        startCountdown();
    };

    init();
};
